import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { BuildRounded, Tune, ViewCarouselRounded, ViewQuiltRounded, } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { DeviceState } from 'console/shared/contexts/device/state/types';
import { useAnchor } from 'shared/hooks/utils';
import { UIControlMenu } from './ui-control-menu';
import { useAppSelector } from 'shared/hooks/redux/hooks';
const style = { padding: 0.5 };
export const UIControlButton = memo(function UIControlButton(props) {
    const { color } = props;
    const { sorting_mode, simple_view_mode } = useContext(DeviceUISettingsContent);
    const { is_service_mode } = useContext(DeviceState);
    const [menu_anchor, openMenu, closeMenu] = useAnchor();
    const icon = useMemo(() => simple_view_mode ? (_jsx(ViewCarouselRounded, { color: color || 'primary' })) : sorting_mode ? (_jsx(ViewQuiltRounded, { color: color || 'primary' })) : is_service_mode ? (_jsx(BuildRounded, { color: color || 'warning' })) : (_jsx(Tune, { color: color || 'action' })), [simple_view_mode, sorting_mode, is_service_mode, color]);
    const nextUiGuide = useAppSelector((state) => state.ui_guide_state.store_helpers.next);
    const onClick = useCallback((event) => {
        openMenu(event);
        nextUiGuide?.();
    }, [nextUiGuide]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: "flex", justifySelf: "flex-end", color: "inherit", children: _jsx(IconButton, { onClick: onClick, sx: style, color: "inherit", "data-tooltip": "modal-button-service-view", children: icon }) }), _jsx(UIControlMenu, { onClose: closeMenu, anchor: menu_anchor })] }));
});
